import { baseApi } from '@/config/axios';
import {
  CustomerInfoApiParams,
  CustomerInfoApiResponse,
  UpdateEmailApiParams,
  UpdateEmailApiResponse,
  UpdatePasswordApiParams,
  UpdatePasswordApiResponse,
} from '@/types/api/customerApi';
import {
  UpdateWarrantyCustomerParams,
  UpdateWarrantyCustomerResponse,
} from '@/types/api/warrantyApi';
import {
  registerCustomerInfoRestrictionRequest,
  startPrepaidRestrictionRequest,
} from '@/utils/prepaidRestrictionRequest';
import { selectedTenantFor } from '@/utils/selectedTenant';

// 5.基礎情報取得
// 表示中テナント向けの取得が必要な呼び出し元だけ明示的に opt in する。
// それ以外は顧客の所属法人を基準に取得する。
export const customerInfoApi = (
  params: CustomerInfoApiParams,
  options: { applySelectedTenant?: boolean } = {},
): Promise<
  CustomerInfoApiResponse & { requestedAffiliateId: number | null }
> => {
  // 取得する顧客が選んだ切り替えだけを付ける（車両切り替えで別の顧客を取得する時は付けない）
  const selectedTenant = options.applySelectedTenant
    ? selectedTenantFor(params.m_customer_id)
    : null;
  const requestedAffiliateId = selectedTenant?.m_affiliate_id;
  const selectedTenantId = selectedTenant?.m_affiliate_id ?? null;
  const requestId = startPrepaidRestrictionRequest();
  return baseApi
    .get('v1/customer/info', {
      params: {
        ...params,
        ...(selectedTenant
          ? { switch_m_affiliate_id: selectedTenant.m_affiliate_id }
          : {}),
      },
    })
    .then((response: CustomerInfoApiResponse) => {
      registerCustomerInfoRestrictionRequest(response.data.customer, {
        customerId: params.m_customer_id,
        selectedTenantId,
        requestId,
      });
      return {
        ...response,
        // リクエスト時点の対象法人を保持する。応答までに選択先が変わっても再計算しない。
        requestedAffiliateId:
          requestedAffiliateId ??
          response.data.customer?.m_affiliate_id ??
          null,
      };
    });
};

// 26. パスワード変更
export const updatePasswordApi = (
  params: UpdatePasswordApiParams,
): Promise<UpdatePasswordApiResponse> =>
  baseApi.put('v1/customer/password-change', { ...params });

// 75. メールアドレス変更処理
export const updateEmailApi = (
  params: UpdateEmailApiParams,
): Promise<UpdateEmailApiResponse> =>
  baseApi.put('v1/customer/email-change', { ...params });

// 21. お客様情報更新
export const updateCustomerApi = (
  params: UpdateWarrantyCustomerParams,
): Promise<UpdateWarrantyCustomerResponse> =>
  baseApi.put('v1/customer', params);
